import React from 'react';
import { isSmartPhone, random } from '../../utilities/helper';
import LeaderBoardPvpGamesWeb from './index_web';
import { useLink, useRouteLocation } from 'react-router-stack';
import { useDispatch, useSelector } from 'react-redux';
import { addGameToHistory, setMiniGamesData } from '../../actions/mini-games-action-types';
import { updateGameType } from '../../actions/user-actions-types';
import constants from '../../constants';
import LeaderBoardPvpGamesMWeb from './index_mWeb';
const LeaderBoardPvpGames = () => {
  const navigate = useLink();
  const location = useRouteLocation();
  const { pathname = '' } = location;
  const isLeaderBoardGames = pathname === '/leaderboard_games';
  const dispatch = useDispatch();
  const { miniGamesList = [] } = useSelector((state: any) => state.minigames);

  const leaderBoardGameList = miniGamesList.filter(
    (game: any) => game.gameType !== 'playerVsPlayer'
  );
  const quizGames = miniGamesList.filter((item: any) => item.category === 'quiz');
  const sportsGames = miniGamesList.filter((item: any) => item.category === 'sports');
  const arcadeGames = miniGamesList.filter((item: any) => item.category === 'arcade');
  const racingGames = miniGamesList.filter((item: any) => item.category === 'racing');
  const puzzleGames = miniGamesList.filter((item: any) => item.category === 'puzzles');
  const strategyGames = miniGamesList.filter((item: any) => item.category === 'strategy');
  const pvpGamesList = miniGamesList.filter((game: any) => game.gameType === 'playerVsPlayer');
  const randomIdx = isLeaderBoardGames
    ? random(0, leaderBoardGameList.length)
    : random(0, pvpGamesList.length);

  const topGame = isLeaderBoardGames ? leaderBoardGameList[randomIdx] : pvpGamesList[randomIdx];

  const suggestionsHandler = (gameData: any) => {
    if (gameData.gameName === 'Poker') {
      navigate.push('/poker');
      dispatch(addGameToHistory(gameData));
    } else if (gameData.gameName === 'Fantasy Cricket') {
      dispatch(updateGameType(constants.GameType.FANTASY_CRICKET));
      dispatch(addGameToHistory(gameData));

      navigate.push('/fantasy', {
        title: 'Fantasy Cricket',
        gameType: constants.GameType.FANTASY_CRICKET
      });
    } else {
      dispatch(setMiniGamesData(gameData));
      navigate.push('/prizes');
    }
  };
  const onClickViewAll = (url: any) => {
    navigate.push(url);
  };
  return (
    <React.Fragment>
      {!isSmartPhone ? (
        <LeaderBoardPvpGamesWeb
          suggestionsHandler={suggestionsHandler}
          onClickViewAll={onClickViewAll}
          topGame={topGame}
          isLeaderBoardGames={isLeaderBoardGames}
          quizGames={quizGames}
          sportsGames={sportsGames}
          arcadeGames={arcadeGames}
          racingGames={racingGames}
          puzzleGames={puzzleGames}
          strategyGames={strategyGames}
        />
      ) : (
        <LeaderBoardPvpGamesMWeb
          suggestionsHandler={suggestionsHandler}
          onClickViewAll={onClickViewAll}
          topGame={topGame}
          isLeaderBoardGames={isLeaderBoardGames}
          quizGames={quizGames}
          sportsGames={sportsGames}
          arcadeGames={arcadeGames}
          racingGames={racingGames}
          puzzleGames={puzzleGames}
          strategyGames={strategyGames}
        />
      )}
    </React.Fragment>
  );
};

export default LeaderBoardPvpGames;
